// Status de contrato do sis-contratos (CRM externo).
// Códigos reais de GET /general-reports/status-contracts (sis-contratos) —
// não documentados no Swagger, confirmados chamando o relatório direto.
const STATUSES = [
  { code: 10, label: "Ativo", color: "light-success" },
  { code: 90, label: "Suspenso", color: "light-warning" },
  { code: 99, label: "Cancelado", color: "light-danger" },
  { code: "00", label: "Em andamento", color: "light-info" },
  { code: 21, label: "Aprovado", color: "light-info" },
  { code: "MIGRATION", label: "Desconhecido", color: "light-secondary" },
  { code: "SIS-SYNC", label: "Desconhecido", color: "light-secondary" },
];

// Chave dupla: código bruto (como vem da API) e label já traduzido (usado
// por telas que só têm o texto, ex: ListaContratos), ambos resolvendo pra
// mesma cor/label.
export const CONTRATO_STATUS = STATUSES.reduce(
  (acc, { code, label, color }) => {
    acc[code] = { label, color };
    acc[label] = { label, color };
    return acc;
  },
  {},
);

// Só os status reais (sem os aliases por label, sem MIGRATION/SIS-SYNC) —
// pra popular dropdowns de filtro sem duplicar.
export const CONTRATO_STATUS_OPTIONS = STATUSES.filter(
  ({ code }) => code !== "MIGRATION" && code !== "SIS-SYNC",
).map(({ code, label }) => ({ value: code, label }));
